import React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
    Navigate,
} from "react-router-dom";
import Inicio from './pages/Inicio';
import Recorre from './pages/Recorre';
import Plantas from './pages/Plantas';
import Interiores from './pages/Interiores';
import ViveEstilo from './pages/ViveEstilo';
import Explorar from './pages/Explorar';
import Cotiza from './pages/Cotiza';


const App = () => {
    return (
        <Router>
            <header>
                <div className='phone-menu'>
                    <div className='items'>
                        <div className='item'>
                            <Link to="/vive-estilo">
                                <div className='imagen'>
                                    <img src="/images/header/icono_1_celular.svg" alt="icono_1_celular" />
                                </div>
                                <p>Vive Estilo</p>
                            </Link>
                        </div>
                        <div className='item'>
                            <Link to="/recorre">
                                <div className='imagen'>
                                    <img src="/images/header/icono_2_celular.svg" alt="icono_1_celular" />
                                </div>
                                <p>Recorre</p>
                            </Link>
                        </div>
                        <div className='item'>
                            <Link to="/plantas">
                                <div className='imagen'>
                                    <img src="/images/header/icono_3_celular.svg" alt="icono_1_celular" />
                                </div>
                                <p>Ver Plantas</p>
                            </Link>
                        </div>
                        <div className='item'>
                            <Link to="/interiores">
                                <div className='imagen'>
                                    <img src="/images/header/icono_4_celular.svg" alt="icono_1_celular" />
                                </div>
                                <p>Interiores</p>
                            </Link>
                        </div>
                        <div className='item'>
                            <Link to="/explorar">
                                <div className='imagen'>
                                    <img src="/images/header/icono_5_celular.svg" alt="icono_1_celular" />
                                </div>
                                <p>Explora</p>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className='desk-menu'>
                    <div className='logo'>
                        <div className='tablet'>
                            <Link to="/">
                                <img src="/images/logo_tablet.png" alt="logo Edificio Almirante" />
                            </Link>
                        </div>
                        <div className='note'>
                            <Link to="/">
                                <img src="/images/logo_tablet.png" alt='logo Edificio Almirante' />
                            </Link>
                        </div>

                    </div>
                    <ul>
                        <li>
                            <Link to="/">INICIO</Link>
                        </li>
                        <li>
                            <Link to="/recorre">RECORRE</Link>
                        </li>
                        <li>
                            <Link to="/plantas">PLANTAS</Link>
                        </li>
                        <li>
                            <Link to="/interiores">INTERIORES</Link>
                        </li>
                        <li>
                            <Link to="/explorar">EXPLORA</Link>
                        </li>
                        <li>
                            <Link to="javascript:void(null);" data-bs-toggle="modal" data-bs-target="#modalCotizar">COTIZA</Link>
                        </li>
                    </ul>
                </div>
            </header>
            <Routes>
            //Links internos
                <Route exact path="/cotizar" element={<Cotiza />} />
                <Route exact path="/vive-estilo" element={<ViveEstilo />} />
                <Route exact path="/recorre" element={<Recorre />} />
                <Route exact path="/plantas" element={<Plantas />} />
                <Route exact path="/interiores" element={<Interiores />} />
                <Route exact path="/explorar" element={<Explorar />} />
                <Route exact path="/" element={<Inicio />} />
            </Routes>
            <footer>
                <div className='logo'>
                    <div className='phone'>
                        <img
                            src="/images/footer/logo_footer_celular.png"
                            alt="icono_1_celular"
                        />
                    </div>

                    <div className='tablet'>
                        <img
                            src="/images/logo_footer_tablet.png"
                            alt="logo_footer_tablet"
                        />
                    </div>
                    <div className='note'>
                        <img
                            src="/images/logo_footer_tablet.png"
                            alt="logo_footer_tablet"
                        />
                    </div>
                </div>
                <p>Imágenes referenciales. Los textos, imágenes y planos contenidos en la presente página fueron elaboradas con fines meramente ilustrativos y referenciales, no constituyendo representación exacta a la realidad. Su objetivo es mostrar una caracterización general del proyecto y no sus detalles. Lo anterior se informa en virtud de lo señalado en la Ley 19.496.</p>
            </footer>

            <a href='javascript:void(null);' id='btn-cotizar' data-bs-toggle="modal" data-bs-target="#modalCotizar">
                <div className='icon'>
                    <img
                        src="/images/icono_cotiza_online.svg"
                        alt="icon_cotizar"
                    />
                </div>
                <div className='texto'>
                    <p>
                        Cotiza <span>Online</span>
                    </p>
                </div>
            </a>

            <div class="modal fade" id="modalCotizar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog  modal-xl modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div className='image'>
                                <a href='javascript:void(null);' data-bs-dismiss="modal" >
                                    <img
                                        src="/images/cerrar.png"
                                        alt="icon_cotizar"
                                    />
                                </a>
                            </div>
                            <iframe src="https://cotizacion.mobysuite.com/widget?customer=almirante&project_id=3"
                                frameborder="0"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </Router>
    )
}

export default App;